import * as React from 'react';

import {
  Colors,
} from '@bluecurrent/web-component-lib';

import Divider from './Divider';
import Item from './Item';

export default function XAxis({
  data,
}) {
  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        borderTop: `solid 4px ${Colors.MEDIUM_GREY}`,
        display: 'flex',
        flexDirection: 'row',
      }}
    >
      {
        data.map((item, index) => {
          const previousHour = index > 0 ? data[index - 1].hour : null;

          return item.type === 'divider'
            ? (
              <Divider
                key={item.id}
                isSolid={previousHour === '23'}
              />
            ) : (
              <Item
                key={item.id}
                hour={item.hour}
                index={index}
              />
            );
        })
      }
    </div>
  );
}
